import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  isCollapsed = true;
  data = [{
    status: true,
    name: 'LIGHTING Explorer'
  },
  {
    status: true,
    name: 'OFFICE'
  },
  {
    status: true,
    name: 'HOTEL'
  },
  {
    status: true,
    name: 'Home'
  },
  {
    status: false,
    name: 'All Products'
  },
  {
    status: false,
    name: 'PENDANT LIGHT'
  },
  {
    status: false,
    name: 'CHANDELIER'
  },
  {
    status: false,
    name: 'SWITCHES & SOCKETS'
  },
  {
    status: false,
    name: 'CEILING LAMP'
  },
  {
    status: false,
    name: 'WALL LAMP'
  }
]
  constructor() { }

  ngOnInit() {
  }

}
